import { AGREEMENT } from './index.js';
export default {
  data() {
    return {
      agreement: AGREEMENT
    };
  }
};